import * as Sentry from '@sentry/browser';
import { isProduction } from '../utils/environment.utils';
import config from '../config';

Sentry.init({
  dsn: config.sentryDSN,
  environment: config.sentryEnvironment,
  enabled: isProduction,
});
